import React from "react";
import { Box, Grid, Text } from "@chakra-ui/react";

export const TransactionsHeaderRow: React.FC = () => {
  return (
    <Box
      borderBottomWidth="1px"
      borderColor="blackAlpha.100"
      py={2}
      px={3}
      bg="white"
    >
      <Grid
        templateColumns={{ base: "1fr", md: "2fr 1fr 1fr 2fr" }}
        gap={3}
        alignItems="center"
      >
        <Text fontSize="xs" fontWeight="bold" color="gray.600">
          TRANSACTIONS
        </Text>

        <Text
          fontSize="xs"
          fontWeight="bold"
          color="gray.600"
          display={{ base: "none", md: "block" }}
        >
          AMOUNT
        </Text>

        <Text
          fontSize="xs"
          fontWeight="bold"
          color="gray.600"
          display={{ base: "none", md: "block" }}
        >
          STATUS
        </Text>

        <Text
          fontSize="xs"
          fontWeight="bold"
          color="gray.600"
          display={{ base: "none", md: "block" }}
        >
          COMMENTS
        </Text>
      </Grid>
    </Box>
  );
};
